export class TimeframeFetcher {
  constructor(apiFetch) {
    this.apiFetch = apiFetch;
    this.cache = new Map();
  }

  fetchTimeframe(schoolYearType, schoolYearId) {
    const cacheKey = `${schoolYearType}-${schoolYearId}`;
    if (this.cache.has(cacheKey)) {
      return Promise.resolve(this.cache.get(cacheKey));
    }

    return this.apiFetch.get({}, `lock_timeframes?school_year_id=${schoolYearId}&school_year_type=${schoolYearType}`)
      .then((data) => {
        this.cache.set(cacheKey, data.timeframe);
        return data.timeframe;
      });
  }
}
